module.exports = __webpack_public_path__ + "img/9788960172890.917627c8.jpg";